<template>
  <div class="create">
    <form-title>账号信息</form-title>
    <info-panel>
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="90px"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="机构名称"
              prop="agencyName"
            >
              <el-input v-model="createForm.agencyName" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="负责人"
              prop="chargePersonName"
            >
              <el-input v-model="createForm.chargePersonName" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="负责人电话"
              prop="chargePersonPhone"
            >
              <el-input v-model="createForm.chargePersonPhone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="省市区"
              prop="provinceInfo"
            >
              <el-cascader
                v-model="createForm.provinceInfo"
                :props="cascaderProps"
                :options="province"
                @change="formatCity"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="详细地址"
              prop="agencyAddress"
            >
              <el-input v-model="createForm.agencyAddress" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="备注"
              prop="remark"
            >
              <el-input v-model="createForm.remark" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="机构座机"
              prop="agencyTelephone"
            >
              <el-input v-model="createForm.agencyTelephone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="营业执照"
              prop="businessLicense"
            >
              <upload :file-list.sync="createForm.businessLicense" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
    <form-title>人员信息</form-title>
    <div class="flex">
      <el-button-group class="switch-btns">
        <el-button
          :type="switchBtnKey?'primary':'default'"
          @click="switchBtnHandler(true)"
        >
          机构人员
        </el-button>
        <el-button
          :type="!switchBtnKey?'primary':'default'"
          @click="switchBtnHandler(false)"
        >
          机构辅导员
        </el-button>
      </el-button-group>
      <span>
        <el-button
          type="primary"
          :disabled="!isEditType || !switchBtnKey"
          @click="addAgencyIdentity"
        >新增人员</el-button>
      </span>
    </div>
    <data-table
      :data="agencyTabelData"
      :pagination="pagination"
      :table-column="switchBtnKey ? agencyUserTableColumn : agencyCounselorTableColumn"
      @changeCheckboxSingle="changeCheckboxSingle"
      @buttonClick="buttonClick"
    />
    <el-row
      :gutter="20"
      class="submit"
    >
      <el-col class="btns">
        <el-button @click="cancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          保存
        </el-button>
      </el-col>
    </el-row>
    <wx-user-info
      :dialog-visible.sync="dialogVisible"
      @getWxInfo="getWxInfo"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import axClient from '@/services';
import types from '@/config';
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';
import wxUserInfo from '@/components/common/userWxInfo.vue';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'AgencyEdit',
  components: {
    formTitle,
    infoPanel,
    dataTable,
    wxUserInfo,
    upload,
  },
  data() {
    return {
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'sonList',
      },
      dialogVisible: false,
      createForm: {
        id: '',
        chargePersonName: '', // 负责人
        chargePersonPhone: '', // 负责人电话
        agencyName: '', // 机构名称
        agencyTelephone: '', // 机构座机
        provinceId: '', // 省份
        cityId: '', // 城市
        areaId: '', // 区域
        provinceInfo: null,
        businessLicense: '', // 营业执照
        agencyAddress: '', // 机构地址
        remark: '', // 备注
        valid: types.INDENTITY_VALID_ENABLE,
      },
      creatRules: {
        agencyName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
        ],
        chargePersonName: [
          { required: true, message: '请输入负责人', trigger: 'blur' },
        ],
        chargePersonPhone: [
          { required: true, message: '请输入负责人电话', trigger: 'blur' },
        ],
        provinceInfo: [
          { required: true, message: '请选择地址', trigger: 'blur' },
        ],
        agencyAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
      },
      result: {
        agencyUserList: [],
        agencyCounselorList: [],
      },
      pagination: false,
      switchBtnKey: true,
      isEditType: !!this.$route.params.id,
      agencyUserTableColumn: [
        {
          key: 'isReceiveAccount',
          label: '状态',
          width: '60px',
          dataType: 'component',
          renderProps: '',
          render: () => 'checkboxSingle',
        },
        {
          key: 'wechatNickName',
          label: '微信昵称',
          width: '160px',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '联系电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'identityValid',
          label: '状态',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.INDENTITY_VALID_ENABLE]: '启用', [types.INDENTITY_VALID_DISABLE]: '禁用', successKey: types.INDENTITY_VALID_ENABLE },
          render: () => 'status',
        },
        {
          key: 'createByName',
          label: '创建人',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'identityCreateTime',
          label: '修改时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '启用', renderKey: types.INDENTITY_VALID_DISABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '禁用', renderKey: types.INDENTITY_VALID_ENABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      agencyCounselorTableColumn: [
        {
          key: 'userRealName',
          label: '人员姓名',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '联系电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'identityValid',
          label: '状态',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.INDENTITY_VALID_ENABLE]: '启用', [types.INDENTITY_VALID_DISABLE]: '禁用', successKey: types.INDENTITY_VALID_ENABLE },
          render: () => 'status',
        },
        {
          key: 'identityCreateTime',
          label: '修改时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '启用', renderKey: types.INDENTITY_VALID_DISABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '禁用', renderKey: types.INDENTITY_VALID_ENABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      data: {},
    };
  },
  computed: {
    ...mapGetters(['province']),
    agencyTabelData() {
      if (this.switchBtnKey && this.result) {
        return this.result.agencyUserList;
      }
      return this.result.agencyCounselorList;
    },
  },

  mounted() {
    this.getInfo();
  },
  methods: {
    // 取消
    cancel() {
      window.history.back();
    },
    // 提交
    async submit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.agency.upsertAgency(this.createForm);
          if (data) {
            if (this.isEditType) {
              this.$message.success('编辑机构成功');
            } else {
              this.$message.success('新增机构成功');
            }
            this.$router.push({ name: 'AgencyList' });
          }
        }
      });
    },
    // 是否编辑信息
    async getInfo() {
      if (this.isEditType) {
        // 编辑
        this.result = await axClient.agency.getInfo(this.$route.params.id);
        const {
          chargePersonName,
          chargePersonPhone,
          agencyName,
          agencyTelephone,
          provinceId,
          cityId,
          areaId,
          businessLicense,
          agencyAddress,
          remark,
          valid,
          id,
        } = this.result;
        this.createForm = {
          id,
          chargePersonName,
          chargePersonPhone,
          agencyName,
          agencyTelephone,
          provinceId,
          cityId,
          areaId,
          provinceInfo: [provinceId, cityId, areaId],
          businessLicense,
          agencyAddress,
          remark,
          valid,
        };
      }
    },
    // 处理省市区
    formatCity(item) {
      const [provinceId, cityId, areaId] = item;
      this.createForm = Object.assign(this.createForm, { provinceId, cityId, areaId });
    },
    // 切换显示机构人员
    switchBtnHandler(val) {
      this.switchBtnKey = val;
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.deleteAccount(item);
          break;
        default:
          break;
      }
    },
    // 设置收款账号
    async changeCheckboxSingle(item) {
      const { identityId } = item;
      const data = await axClient.agency.updateIsReceiveAccount({
        agencyId: this.$route.params.id,
        identityId,
      });
      if (data) {
        this.$message.success('设置成功');
        this.getInfo();
      }
    },
    // 获取查询的微信人员信息
    async getWxInfo(data) {
      const { id } = data;
      const res = await axClient.agency.insertAgencyIdentity({
        agencyId: this.$route.params.id,
        userId: id,
      });
      if (res) {
        this.$message.success('新增机构人员成功');
      }
      this.getInfo();
    },
    // 新增人员
    addAgencyIdentity() {
      this.dialogVisible = true;
    },
    // 禁用/启用 账号
    confirmDialog(item) {
      this.$confirm('确定禁用/启用该账号？', '禁用/启用账号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { identityId, identityValid } = item;
        const data = await axClient.account.updateEntityValid(
          {
            identityId,
            identityValid: identityValid === types.INDENTITY_VALID_ENABLE
              ? types.INDENTITY_VALID_DISABLE : types.INDENTITY_VALID_ENABLE,
          },
        );
        if (data) {
          this.$message.success('启用/禁用成功');
          this.getInfo();
        }
      });
    },
    // 删除账号
    deleteAccount(item) {
      this.$confirm('确定删除该人员？', '删除机构人员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { identityId } = item;
        const data = await axClient.agency.deleteAgencyIdentity(
          {
            identityId,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getInfo();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.data-table {
  margin: 24px 0;
}
.submit {
  text-align: center;
}
</style>